import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../authcontext/authContext";

import styled, { keyframes } from "styled-components";
import { makeRequest } from "../../axios";


const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg,rgb(23, 52, 39),rgb(60, 134, 114));
  font-family: "Arial", sans-serif;
`;

const FormWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
  animation: ${fadeIn} 0.8s ease;
`;

const Title = styled.h2`
  text-align: center;
  color: #333;
  margin-bottom: 20px;
`;

const Subtitle = styled.p`
  text-align: center;
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 15px;
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  transition: 0.3s ease;

  &:focus {
    border-color: #2575fc;
    outline: none;
    box-shadow: 0 0 5px rgba(37, 117, 252, 0.5);
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 12px 15px;
  border: none;
  border-radius: 8px;
  background:rgb(29, 67, 57);
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s ease;

  &:hover {
    background:rgb(69, 116, 97);
  }
`;

const AnimationWrapper = styled.div`
  text-align: center;
  margin-top: 20px;

  & img {
    width: 80px;
    animation: bounce 2s infinite;
  }

  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }
`;

const SuccessMessage = styled.p`
  text-align: center;
  color: #28a745;
  font-size: 14px;
  margin-top: 10px;
`;

const ForgottenPassword = () => {
 const [email, setEmail] = useState({email:""});
 const [success, setSuccess] = useState(false);
 const [err, setErr] = useState(null);


 const navigate = useNavigate()
 const { passr } = useContext(AuthContext);


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await passr(email);
    } catch (err) {
      setErr(err.response.data);
    }
    // Add email validation or backend integration here
    setSuccess(true);
    navigate("/verifyotp")
  };

  return (
    <Container>
      <FormWrapper>
        <Title>Forgot Password?</Title>
        <Subtitle>Enter your registered email address to reset your password.</Subtitle>
        <form onSubmit={handleSubmit}>
          <Input
            type="email"
            placeholder="Enter your email"
            name="email"
            value={email.email}
            onChange={(e) => setEmail((prev) => ({ ...prev, [e.target.name]: e.target.value }))}
            required
          />
          <Button type="submit">Verify Email</Button>
        </form>
        {success && (
          <SuccessMessage>
            An OTP has been sent to your email!
          </SuccessMessage>
        )}
        <AnimationWrapper>
          <img
            src="https://cdn-icons-png.flaticon.com/512/847/847969.png"
            alt="Envelope Animation"
          />
        </AnimationWrapper>
      </FormWrapper>
    </Container>
  );
};

export default ForgottenPassword;
